<template>
  <div class="comp-note fit-height">
    <div class="note-info">
      <div class="client" v-if="note.client">{{ note.client.name }}</div>
      <div class="title">
        <template v-if="editTitle">
          <form method="post" action="" @submit.prevent="saveTitle">
            <input type="text" class="form-control" v-model="newTitle" ref="inputTitle" @blur="saveTitle">
          </form>
        </template>
        <template v-else>
          <span>{{ note.title }}</span>
          <a href="javascript:;" class="edit icon-pencil"
            @click="editTitle = true"></a>
        </template>
      </div>
    </div>
    <div :class="{ showAttachment: 'with-sidebar' }">
      <div class="body">
        <template v-if="editContent">
          <form method="post" @submit.prevent="saveContent">
            <div class="form-group">
              <editor :api-key="tinyApiKey" :init="tinyOpts" v-model="newContent"></editor>
            </div>
            <button type="submit" class="btn btn-outline-black">Submit</button>&nbsp;
            <button type="button" class="btn btn-outline-gray" @click="editContent = false">Cancel</button>
          </form>
        </template>
        <template v-else>
          <div class="mb-5" v-html="note.content"></div>
          <button type="button" class="btn btn-outline-black w180" @click="editContent = true">Edit</button>
        </template>
      </div>

      <aside class="sidebar" v-if="showAttachment">
        <attachments></attachments>
      </aside>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Attachments from '../global/Attachments.vue';
  import Editor from '@tinymce/tinymce-vue'
  import ServiceNote from '@/services/note'

  export default {
  components: {
    Attachments,
    Editor,
  },
  data () {
    return {
      showAttachment: false,
      editTitle: false,
      editContent: false,
      note: {},
      newTitle: '',
    }
  },
  computed: {
    ...mapState({
      tinyApiKey: state => state.option.tinyApiKey,
      tinyOpts: state => state.option.tinyOpts
    }),
  },
  props: ['noteId'],
  watch: {
    noteId: 'init',
    editTitle (newVal) {
      let self = this;
      if ( newVal ) {
        self.newTitle = self.note.title;
        setTimeout(() => {
          self.$refs.inputTitle.focus();
        }, 200);
      }
    },
    editContent (newVal) {
      let self = this;
      if ( newVal ) {
        self.newContent = self.note.content;
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.getNote();
    },
    getNote () {
      let self = this;
      ServiceNote.getNote(self.noteId, resp => {
        self.note = resp;
      });
    },
    saveTitle () {
      let self = this;
      if (self.note.title != self.newTitle) {
        ServiceNote.save(self.noteId, {title: self.newTitle}, function(){
          self.note.title = self.newTitle;
          self.editTitle = false;
        });
      }
    },
    saveContent () {
      let self = this;
      if (self.note.content != self.newContent) {
        ServiceNote.save(self.noteId, {content: self.newContent}, function(){
          self.note.content = self.newContent;
          self.editContent = false;
        });
      }
    }
  }
}
</script>
